<template>
    <ToggleSimple @update:open="toggleOpen = $event">
        <template #toggle>
            <div class="left">
                <div v-if="$te(`fields.${name}.label`)" class="toggle-text">
                    {{ $t(`fields.${name}.label`) }}
                    <span v-if="isActive">
                        <div class="icon-check-dark"></div>
                    </span>
                </div>
                <div v-if="$te(`fields.${name}.description`)" class="toggle-description">
                    {{ $t(`fields.${name}.description`) }}
                </div>
            </div>
            <div class="right">
                <div v-if="isActive" class="reset" @click="resetSection">
                    <div class="icon-reset-pos"></div>
                </div>
                <div class="toggle-icon"></div>
            </div>
        </template>

        <template #content>
            <div :class="cssClassOptions">
                <CustomSelect
                    :modelValue="modelValue"
                    :inputKey="name"
                    @update:modelValue="onChanged"
                    :options="options"
                    :showLabel="false"
                    :showDescription="false"
                    ref="optionsLabel"
                />
            </div>
        </template>
    </ToggleSimple>
</template>

<script>
    import ToggleSimple from '@/components/misc/ToggleSimple';
    import CustomSelect from '@/components/inputs/CustomSelect';

    export default {
        name: "OptionsLabel",
        components: {
            ToggleSimple,
            CustomSelect
        },
        props: {
            modelValue: {
                type: String,
                default: 'all'
            },
            defaultVal: {
                type: String,
                default: 'all'
            },
            showDescriptions: {
                type: Boolean,
                default: true
            },
            cssClassOptions: {
                type: String,
                default: 'options-type-4'
            }
        },
        data() {
            return {
                name: 'prospects_filter_label_alt',
                toggleOpen: false,
                options: [
                    { value: 'all', text: 'fields.prospects_filter_label_alt.option_all' },
                    { value: '1', text: 'fields.prospects_filter_label_alt.option_1' },
                    { value: '0', text: 'fields.prospects_filter_label_alt.option_0' },
                    { value: '-1', text: 'fields.prospects_filter_label_alt.option_-1' },
                ],
            };
        },
        computed: {
            isActive() {
                return JSON.stringify(this.modelValue) !== JSON.stringify(this.defaultVal);
            }
        },
        methods: {
            resetSection(event = null) {
                if (event) {
                    event.stopPropagation()
                }
                this.$emit('update:modelValue', this.defaultVal);
            },
            onChanged(newValue) {
                this.$emit('update:modelValue', newValue);
            },
        }
    }
</script>